"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.sendFeedback = sendFeedback;
exports.resetFeedback = resetFeedback;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEND_FEEDBACK = "maaporssi/feedback/SEND_FEEDBACK";
var SEND_FEEDBACK_SUCCESS = "maaporssi/feedback/SEND_FEEDBACK_SUCCESS";
var SEND_FEEDBACK_FAIL = "maaporssi/feedback/SEND_FEEDBACK_FAIL";
var SEND_FEEDBACK_RESET = "maaporssi/feedback/SEND_FEEDBACK_RESET";

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SEND_FEEDBACK:
      return (0, _extends3.default)({}, state, {
        sendFeedbackLoading: true
      });
    case SEND_FEEDBACK_FAIL:
      return (0, _extends3.default)({}, state, {
        sendFeedbackLoading: false,
        sendFeedbackSuccess: false,
        sendFeedbackError: true
      });
    case SEND_FEEDBACK_SUCCESS:
      return (0, _extends3.default)({}, state, {
        sendFeedbackLoading: false,
        sendFeedbackSuccess: true,
        sendFeedbackError: null
      });
    case SEND_FEEDBACK_RESET:
      return (0, _extends3.default)({}, state, {
        sendFeedbackLoading: false,
        sendFeedbackSuccess: false,
        sendFeedbackError: null
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.feedback && globalState.feedback.loaded;
}

function sendFeedback(formData) {
  return {
    types: [SEND_FEEDBACK, SEND_FEEDBACK_SUCCESS, SEND_FEEDBACK_FAIL],
    promise: function promise(client) {
      return client.post("/feedbacks", {
        data: formData
      });
    }
  };
}

function resetFeedback() {
  return {
    type: SEND_FEEDBACK_RESET
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/feedback.js
 ** module id = 493
 ** module chunks = 0
 **/